import * as actions from './overview.actions';
import { OverviewData } from './overview.models';

export interface State {
  loading: boolean;
  data?: OverviewData;
}

export const initialState: State = {
  loading: false,
  data: undefined
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.ActionTypes.LOAD_WIDGETS_DATA:
      return { ...state, loading: true };
    case actions.ActionTypes.LOAD_WIDGETS_DATA_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case actions.ActionTypes.LOAD_WIDGETS_DATA_FAILED:
      return { ...state, loading: false, data: undefined };

    case actions.ActionTypes.RESET_WIDGETS_DATA:
      return { ...initialState };

    default:
      return state;
  }
}
